module.exports = __webpack_public_path__ + "m-time-68310a01.png";